var ApplicationTypes;
(function (ApplicationTypes) {
    ApplicationTypes["LOGHUB"] = "LogHub";
    ApplicationTypes["SMARTCITY"] = "SmartCity";
})(ApplicationTypes || (ApplicationTypes = {}));
export default ApplicationTypes;
